import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between text-black" }

import BaseModal from "@/components/Modal/BaseModal.vue";


interface Emits {
  (e: "cancel"): void;
  (e: "submit"): void;
}


export default /*#__PURE__*/_defineComponent({
  emits: ["cancel", "submit"],
  setup(__props, { emit }: { emit: ({
  (e: "cancel"): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const endNowTimeout = 30 * 1000; // 30 seconds


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    onCloseOnTimeout: _cache[2] || (_cache[2] = ($event: any) => (emit('submit'))),
    timeout: endNowTimeout
  }, {
    message: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("endNowModalConfirmationText")), 1)
    ]),
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel'))),
          class: "opacity-60 py-3.5 px-6 font-semibold"
        }, _toDisplayString(_ctx.$t("cancel")), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('submit'))),
          class: "bg-inprogress text-white py-3.5 px-6 rounded font-black"
        }, _toDisplayString(_ctx.$t("endReservation")), 1)
      ])
    ]),
    _: 1
  }))
}
}

})